import { useCallback, useRef } from 'react';
import { useDailyEvent } from '@daily-co/daily-react';
import { useSparks } from '../../contexts/SparksContext';

/** Daily app-message the tutor's session sends a child after a shout-out lands. It carries nothing: the child reloads. */
export const SPARKS_REFRESH_MESSAGE = 'sparks-refresh';

/**
 * A child's side of a live class: reloads Sparks state (which drains the server's pending queue, so a tutor
 * shout-out's "+N" shows) when the tutor's ping arrives, and once when the call reconnects after a drop, since
 * a ping sent during the drop is lost. The message only triggers a read; what was awarded always comes from
 * the server. No polling: every reload re-renders each Sparks consumer, the lesson around this included.
 */
export default function SparksClassSync() {
  const { refreshState } = useSparks();
  const interruptedRef = useRef(false);

  useDailyEvent(
    'app-message',
    useCallback(({ data }) => {
      if (data?.type === SPARKS_REFRESH_MESSAGE) refreshState();
    }, [refreshState]),
  );

  useDailyEvent(
    'network-connection',
    useCallback(({ event }) => {
      if (event === 'interrupted') interruptedRef.current = true;
      else if (event === 'connected' && interruptedRef.current) {
        interruptedRef.current = false;
        refreshState();
      }
    }, [refreshState]),
  );

  return null;
}
